module.exports = __webpack_public_path__ + "img/tt.b4c97e5e.svg";